import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=61b37b28&scoped=true&"
var script = {}
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=61b37b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b37b28",
  null
  
)

export default component.exports